export const STORAGES_QUERY_KEY = 'storages'
